export const EtudiantData = [
  {
    id: 21221155,
    matricule: "17T2345",
    nom: "NCHOUWET MFOUAPON",
    prenom: "Kuntz Stephane",
    niveau: "Master 2",
    email: "stephane@gmail.com",
    dateNaissance: "2000-12-10",
    dateSoutenance: "2022-12-10",
    lieuNaissance: "Yaoundé",
    numTelephone: "+237 655 55 55 55",
    sexe: "M",
    urlPhotoProfil:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6n_sDg2-zfzhaGPyi4aXh8TVGfEBj6cLJwQ&usqp=CAU",
    uniteRecherche: {
      id: 56544,
      code: "MIBA",
      intitule: "MATHEMATIQUE INFORMATION BIOSCIENCES ET APPLICATION",
      coordonnateur: {
        id: 123,
        email: "coordonnateur@gmail.com",
        nom: "coordo",
        prenom: "prenom coordo",
      },
    },
  },
];
